import { useEffect, useMemo, useState } from "react";

export function useRandomizedQuizQuestions(questions, stage, storageKey) {
  const [optionOrder] = useState(() => {
    const savedOrder = stage.get(storageKey);
    return Object.fromEntries(questions.map((question) => {
      const values = question.options.map((option) => option.value);
      const saved = savedOrder?.[question.id];
      if (
        Array.isArray(saved) &&
        saved.length === values.length &&
        new Set(saved).size === values.length &&
        values.every((value) => saved.includes(value))
      ) {
        return [question.id, saved];
      }
      for (let index = values.length - 1; index > 0; index -= 1) {
        const swapIndex = Math.floor(Math.random() * (index + 1));
        [values[index], values[swapIndex]] = [values[swapIndex], values[index]];
      }
      return [question.id, values];
    }));
  });

  useEffect(() => {
    stage.set(storageKey, optionOrder);
  }, [optionOrder, stage, storageKey]);

  return useMemo(() => questions.map((question) => ({
    ...question,
    options: [...question.options].sort((a, b) =>
      optionOrder[question.id].indexOf(a.value) - optionOrder[question.id].indexOf(b.value)
    ),
  })), [optionOrder, questions]);
}
